// src/pages/DictPage/hooks/useWeapons.ts
import { useState, useEffect, useCallback } from "react";
import {CreateDictWeaponDto, DictWeapon, UpdateDictWeaponDto} from "../model/Dto/Dict/Weapon";
import {Api} from "../request/api/api";

export function useWeapons(weaponType?: number) {
    const [weapons, setWeapons] = useState<DictWeapon[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchWeapons = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllWeapons(weaponType);
            setWeapons(result);
        } catch (err) {
            setError("Ошибка загрузки оружия");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [weaponType]);

    const createWeapon = useCallback(async (data: CreateDictWeaponDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createWeapon(data);
            if (result) {
                await fetchWeapons();
                return true;
            }
            setError("Ошибка создания оружия");
            return false;
        } catch (err) {
            setError("Ошибка создания оружия");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchWeapons]);

    const updateWeapon = useCallback(async (id: string, data: UpdateDictWeaponDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateWeapon(id, data);
            if (result) {
                await fetchWeapons();
                return true;
            }
            setError("Ошибка обновления оружия");
            return false;
        } catch (err) {
            setError("Ошибка обновления оружия");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchWeapons]);

    const deleteWeapon = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteWeapon(id);
            if (result) {
                await fetchWeapons();
                return true;
            }
            setError("Ошибка удаления оружия");
            return false;
        } catch (err) {
            setError("Ошибка удаления оружия");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchWeapons]);

    useEffect(() => {
        fetchWeapons();
    }, [fetchWeapons]);

    return { weapons, loading, error, createWeapon, updateWeapon, deleteWeapon, refetch: fetchWeapons };
}